import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Slide from "@mui/material/Slide";
import * as React from "react";
import { DialogPaper, HXMobileSheetDialogEl } from "./HXMobileSheetDialog.styles";
import { TitleHeaderView } from "./HXMobileTitleHeader";
import { CloseButton } from "./HXMobileTitleHeader.styles";
import { useWindowSize } from "./useWindowSize";
import { HXMobilePageWithFixedHeaderAndFooterContent } from "./HXMobilePage.styles";
const Transition = React.forwardRef((props, ref) => {
    return _jsx(Slide, { direction: "up", ref: ref, ...props });
});
export const HXMobileSheetDialog = (props) => {
    if (props.container !== undefined) {
        useWindowSize();
    }
    const { disablePortal } = props;
    const [left, setLeft] = React.useState(0);
    const [top, setTop] = React.useState(0);
    const [width, setWidth] = React.useState(0);
    const [height, setHeight] = React.useState(0);
    if (disablePortal) {
        React.useEffect(() => {
            setLeft(0);
            setTop(0);
            setWidth("100%");
            setHeight("100%");
        });
    }
    else if (props.container !== undefined) {
        React.useEffect(() => {
            var _a, _b, _c, _d, _e, _f;
            const rect = (_b = (_a = props.container) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
            setLeft((_c = rect === null || rect === void 0 ? void 0 : rect.left) !== null && _c !== void 0 ? _c : 0);
            setTop((_d = rect === null || rect === void 0 ? void 0 : rect.top) !== null && _d !== void 0 ? _d : 0);
            setWidth((_e = rect === null || rect === void 0 ? void 0 : rect.width) !== null && _e !== void 0 ? _e : 0);
            setHeight((_f = rect === null || rect === void 0 ? void 0 : rect.height) !== null && _f !== void 0 ? _f : 0);
        });
    }
    return (_jsxs(HXMobileSheetDialogEl, { fullScreen: !props.fitToContent, disablePortal: disablePortal, open: props.open, TransitionComponent: props.removeTransition ? undefined : Transition, PaperComponent: DialogPaper, style: props.container !== undefined
            ? {
                left,
                top,
                width,
                height,
            }
            : undefined, roundedCorners: props.roundedCorners, children: [_jsx(TitleHeaderView, { title: props.title, showBottomBorder: true, leftIconButtons: [_jsx(CloseButton, { onClick: props.onClose }, "title-header-close-button")], padButtonsForCenteringTitle: true }), _jsx(HXMobilePageWithFixedHeaderAndFooterContent, { isHeaderAndFooterFixed: true, children: props.children })] }));
};
